const menuButton = document.getElementById("menu-button");
const menu = document.getElementById("menu");
const body = document.body;
const headerLinks = [...document.querySelectorAll(".l-hamburger a[href]")];

function toggleMenu() {
  if (!body.classList.contains("js-menu-open")) {
    body.classList.add("js-menu-open");
    menuButton.setAttribute("aria-expanded", "true");
    menuButton.setAttribute("aria-label", "閉じる");
    menu.inert = false;
  } else {
    body.classList.remove("js-menu-open");
    menuButton.setAttribute("aria-expanded", "false");
    menuButton.setAttribute("aria-label", "メニュー");
    menu.inert = true;
  }
}

if (menuButton) {
  menuButton.addEventListener("click", toggleMenu);
}
headerLinks.forEach((e) => {
  e.addEventListener("click", () => {
    toggleMenu(); //ハンバーガー内にあるページ内メニューがクリックされたらハンバーガーメニューを閉じる
  });
});
